import React from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from "react-redux";
import { HasPermission } from "Core/security";
// Components
import Modal, { ModalBody } from 'Components/Modal';
import Tabs, { TabContainer } from 'Components/Tabs';
//Views
import FormSettings from './components/formSettings';
import QuickMessage from './components/quickMessage';
import QuickResponse from './components/quickResponse';
import DriverStatus from './components/driverStatus';
import TimeCards from './components/timeCards';
import MealBreakNotifications from './components/mealBreakNotifications';



const FsmSettings = (props) => {

    const { handleClose } = props;
    const { messages } = useIntl();
    const user = useSelector(state => state.securityRedux.user)
    //Selectors
    const {
        openSettingsFsm,
        loadingForms
    } = useSelector(state => state.fsmRedux);


    return (
        <Modal
            title={messages['fsm_settings_title']}
            open={openSettingsFsm}
            loading={loadingForms}
            size={`small`}
            handleClose={() => handleClose()}
            position="right"
        >
            <ModalBody style={{ overflow: 'hidden', padding: 10 }}>
                <div
                    style={{
                        padding: "0px 24px 24px 24px",
                        height: "calc(100vh - 190px)"
                    }}
                >
                    <Tabs
                        tab={0}
                        type="icon-indicator"
                        border
                        onChange={(newTab) => {
                        }}
                    >
           
                        
                        <TabContainer
                            iconIndicator="message"
                            label={messages['FSM_SETTINGS_QUICK_MESSAGE']}
                            index={0}
                            style={{ paddingLeft: 0, paddingRight: 0 }}
                        >
                            <QuickMessage />
                        </TabContainer>
                        <TabContainer
                            iconIndicator="send"
                            label={messages['FSM_SETTINGS_QUICK_RESPONSE']}
                            index={1}
                            style={{ paddingLeft: 0, paddingRight: 0 }}
                        >
                            <QuickResponse />
                        </TabContainer>
                        <TabContainer
                            iconIndicator="person"
                            label={messages['FSM_SETTINGS_DRIVER_STATUS']}
                            index={2}
                            style={{ paddingLeft: 0, paddingRight: 0 }}
                        >
                            <DriverStatus />
                        </TabContainer>
                        <TabContainer
                            iconIndicator="timer"
                            label={messages['FSM_SETTINGS_TIME_CARD']}
                            index={3}
                            style={{ paddingLeft: 0, paddingRight: 0 }}
                        >
                            <TimeCards />
                        </TabContainer>
                        <TabContainer
                            iconIndicator="access_time"
                            label={messages['FSM_SETTINGS_TIME_CARD_meal_break_notifications']}
                            index={4}
                            style={{ paddingLeft: 0, paddingRight: 0 }}
                        >
                            <MealBreakNotifications />
                        </TabContainer>

                        {
                            HasPermission(user, "", [105]) &&
                                <TabContainer
                                    iconIndicator="ballot"
                                    label={messages['fsm_settings_form']}
                                    index={5}
                                    style={{ paddingLeft: 0, paddingRight: 0 }}
                                >
                                    <FormSettings />
                                </TabContainer>
                        }

                    </Tabs>
                </div>
            </ModalBody>
        </Modal>
    );
}

export default FsmSettings;